// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__24nV3","button":"styles_button__146Sy"};